// Function to generate a random session token
export const generateSessionToken = () => {
    const session =  [...Array(32)]
        .map(() => Math.random().toString(36)[2])
        .join("");
    sessionStorage.setItem("session",session)
};

